import React from 'react';
import { Home, ListOrdered, CalendarDays, Trophy, MoreHorizontal } from 'lucide-react';
const TABS = [
  { view: 'home', label: '홈', icon: Home }, { view: 'schedule', label: '일정', icon: CalendarDays },
  { view: 'matches', label: '경기', icon: ListOrdered }, { view: 'dashboard', label: '랭킹', icon: Trophy },
  { view: 'more', label: '더보기', icon: MoreHorizontal },
];
export default function Navigation({ setCurrentView, currentView }) {
  const activeView = ['playerDetail', 'playerSearch'].includes(currentView) ? 'dashboard' : TABS.some(t => t.view === currentView) ? currentView : 'more';
  const activeIndex = TABS.findIndex(t => t.view === activeView);
  const items = TABS.map(({ view, label, icon: Icon }) => <a key={view} href={`#${view}`} aria-current={view === activeView ? 'page' : undefined} onClick={e => { e.preventDefault(); setCurrentView(view); }}><Icon size={21} strokeWidth={1.8} aria-hidden="true" /><span>{label}</span></a>);
  return <>
    <a className="skip-link" href="#main-content" onClick={e => { e.preventDefault(); document.getElementById('main-content')?.focus(); }}>본문으로 이동</a>
    <header className="club-header"><div className="club-header-inner">
      <a className="club-wordmark" href="#home" aria-label="TAP 홈" onClick={e => { e.preventDefault(); setCurrentView('home'); }}>TAP<span>.</span><small>TENNIS CLUB</small></a>
      <nav className="desktop-nav" aria-label="주요 메뉴">{items}</nav><span className="club-header-caption">제주대학교 테니스 동아리</span>
    </div></header>
    <nav className="liquid-nav" aria-label="모바일 주요 메뉴" style={{ '--active-index': activeIndex }}><span className="liquid-selection" aria-hidden="true" />{items}</nav>
  </>;
}
